import { ref as n, useId as c, watchEffect as m, createElementBlock as l, openBlock as a, normalizeClass as i, renderSlot as y, createElementVNode as h, createCommentVNode as f, unref as o, createTextVNode as b, toDisplayString as u } from "vue";
import { themeProp as p } from "../../../composables/useTheme.js";
/* empty css                       */
const v = ["id", "for"], g = {
  key: 0,
  class: "ds-color-red"
}, _ = {
  key: 0,
  class: "ds-form-field-layout__message ds-text-small ds-margin-y-3 ds-color-red",
  "data-j-error": ""
}, S = /* @__PURE__ */ Object.assign({
  name: "DsFormFieldLayout"
}, {
  __name: "form-field-layout",
  props: {
    ...p,
    /**
     * Form field label
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Form field message to show when it has error
     */
    errorMessage: {
      type: String,
      default: ""
    },
    /**
     * Form field active state, used to show different styling for the field
     */
    isActive: {
      type: Boolean,
      required: !0
    },
    /**
     * Form field, is a required field
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Form field, has error
     */
    hasError: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const s = e, r = n(s.hasError), t = c();
    return m(() => {
      r.value = s.hasError;
    }), (d, E) => (a(), l("div", {
      class: i(["ds-form-field-layout ds-field-layout", {
        "ds-form-field-layout--active": e.isActive,
        "ds-form-field-layout--error": r.value
      }])
    }, [
      y(d.$slots, "default", { uid: o(t) }),
      h("label", {
        id: `label-${o(t)}`,
        for: o(t),
        class: i(["ds-form-field-layout__label", [{ "ds-form-field-layout__label--active": e.isActive }, `ds-form-field-layout__label--${d.theme}`]])
      }, [
        b(u(e.label) + " ", 1),
        e.required ? (a(), l("span", g, "*")) : f("", !0)
      ], 10, v),
      r.value ? (a(), l("p", _, u(e.errorMessage), 1)) : f("", !0)
    ], 2));
  }
});
export {
  S as default
};
